import * as React from 'react';
import { getProductTealiumDescription } from '@grandvisionhq/fun-products';
import { ProductBlockGallery } from '@grandvisionhq/lib-visuals';
import { ProductListingBlock } from '../ProductListingBlock/ProductListingBlock.js';

const ProductListingGallery = ({ products , isLoading , hasError , reimbursableLogos , productLocation , onProductImpression , onProductInteraction , skus , shouldCenterSlideItems , shouldSendTealiumEvent ,  })=>{
    const renderBlock = ({ blockKey , tabIndex , className , index  })=>{
        const productIndex = products.findIndex(({ masterVariant , variants  })=>masterVariant.sku === blockKey || variants.some(({ sku  })=>sku === blockKey
            )
        );
        const product = products[productIndex];
        if (!product) {
            return null;
        }
        const elementIndex = index || 0;
        const tealiumAttributes = shouldSendTealiumEvent ? {
            'data-element-id': `AlsoLike_Tile_${elementIndex + 1}`,
            'data-description': getProductTealiumDescription(product.name.en, blockKey)
        } : undefined;
        return /*#__PURE__*/ React.createElement(ProductListingBlock, {
            key: blockKey,
            listingProduct: product,
            reimbursableLogos: reimbursableLogos,
            className: className,
            tabIndex: tabIndex,
            productLocation: productLocation,
            onImpression: ()=>{
                return onProductImpression === null || onProductImpression === void 0 ? void 0 : onProductImpression(product, productIndex);
            },
            onInteraction: ()=>{
                return onProductInteraction === null || onProductInteraction === void 0 ? void 0 : onProductInteraction(product, productIndex);
            },
            selectedVariant: blockKey,
            tealiumAttributes: tealiumAttributes
        });
    };
    return /*#__PURE__*/ React.createElement(ProductBlockGallery, {
        isLoading: isLoading,
        hasError: hasError,
        blockKeys: skus,
        renderBlock: renderBlock,
        shouldCenterSlideItems: shouldCenterSlideItems
    });
};

export { ProductListingGallery };
//# sourceMappingURL=ProductListingGallery.js.map
